import Error from '../model/Error.js';
import SepaDirectDebitExport from '../dto/SepaDirectDebitExport.js';
import SepaDirectDebitExportAvailability from '../dto/SepaDirectDebitExportAvailability.js';
import axios from 'axios';

export default class SepaDirectDebitExportRepository {
    static findByClub(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/sepa-direct-debit-exports`)
                .then((response) => resolve(response.data.data.map((data) => SepaDirectDebitExport.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getAvailabilityByClubAndQuery(clubId, query) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/sepa-direct-debit-exports/availability${query}`)
                .then((response) => resolve(SepaDirectDebitExportAvailability.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static createByClub(clubId, start, end, params) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/clubs/${clubId}/sepa-direct-debit-exports?dateRange=${start}:${end}`, params)
                .then((response) => resolve(response))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static download(exportId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/sepa-direct-debit-exports/${exportId}`, { responseType: 'blob' })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const headerLine = response.headers['content-disposition'];
                    const startFileNameIndex = headerLine.indexOf('"') + 1;
                    const endFileNameIndex = headerLine.lastIndexOf('"');
                    const filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    resolve();
                })
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(exportId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/sepa-direct-debit-exports/${exportId}`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static downloadZip(clubId, dateTime) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/sepa-direct-debit-exports/zip/${dateTime}`, { responseType: 'blob' })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const headerLine = response.headers['content-disposition'];
                    const startFileNameIndex = headerLine.indexOf('"') + 1;
                    const endFileNameIndex = headerLine.lastIndexOf('"');
                    const filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    resolve();
                })
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static deleteZip(clubId, dateTime) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/clubs/${clubId}/sepa-direct-debit-exports/zip/${dateTime}`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
